import React, { useState } from 'react'
import NavItem from './NavItem'
import styles from './Header.module.css'
import { Link } from 'react-router-dom'
import LngSwitch from '../LngSwitch/LngSwitch'
export default function Header() {
    const [navActive, changeActive] = useState(false);
    const mobileRedirect = () =>{
        changeActive(false);
        window.scrollTo(0, 0);
    }
    return (
        <div className={styles.headerWrapper}>
            <header className={styles.header}>
                <div>
                
                    <Link to="/">
                        <img className={styles.logo} src="logo.jpeg" alt="UGACSSALogo" />
                    </Link>
                    
                    <span href="." className={styles.toggle} onClick={() => { changeActive(!navActive)}}>
                        <i class="fa fa-bars"></i>
                    </span>
                </div>
                <ul className={`${styles.navList} ${navActive?styles.navActive:styles.navNotActive}`}>
                    <NavItem active={navActive} changeActive={mobileRedirect} />
                </ul>
                <LngSwitch/>
            </header>
        </div>
    )
}
